import React, { Component } from 'react';
import { Collapse, ControlLabel, FormControl, FormGroup, OverlayTrigger, Tooltip, Glyphicon } from 'react-bootstrap';
import { CCOAlert, FieldGroup, CCOButton, CustomButtomView } from '../util/Components.js';
import { clone, getLeaderName, update, toCSV } from '../util/Utility.js';

class Settings extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ministry: null,
      networkAlert: false,
      saved: false,
      baseMinistry: null,
      newStudyTitle: "",
      facebookError: false
    };
  }

  componentWillMount() {
    this.init(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps.ministry) !== JSON.stringify(this.props.ministry)) {
      this.init(nextProps);
    }
  }

  init(props) {
    this.setState({ministry: clone(props.ministry), baseMinistry: clone(props.ministry)})
  }

  validateEmail(email) {
    var re = /^.+@.+\..{2,3}$/;
    return re.test(email);
  }

  save() {

    var ministry = this.state.ministry;

    if (!ministry.email || this.validateEmail(ministry.email)) {
      if (ministry.instagram) {
        if (ministry.instagram.indexOf("@") === 0) {
          ministry.instagram = ministry.instagram.replace("@", "");
        }
      }
      if (ministry.twitter) {
        if (ministry.twitter.indexOf("@") === 0) {
          ministry.twitter = ministry.twitter.replace("@", "");
        }
      }
      if (ministry.facebook && !ministry.facebookID) {
        let fbArr = ministry.facebook.split("/");
        let url = fbArr[fbArr.length - 1];
        if (url === "")
          url = fbArr[fbArr.length - 2];
        fetch('https://graph.facebook.com/' + url + '?access_token=395878660813732|SJYTjp-urfQd-F33qdqdyw7WlzY').then(res => {
          res.json().then(val => {
            ministry.facebookID = val.id;
            this.setState({ministry}, () => this.finishSaving())
          });
        }).catch(() => this.setState({facebookError: true}));
      } else {
        this.finishSaving();
      }
    }
    else {
      this.setState({emailAlert: true});
    }
  }

  finishSaving() {
    let ministry = this.state.ministry;
    update('ministries/' + this.props.ministry.key, this, ministry).then(() => {
      this.setState({baseMinistry: clone(this.state.ministry)});
      window.show('success', 'Saved', 'Your changes were saved successfully');
    }).catch(() => {
      this.setState({networkAlert: true});
    });

    this.props.updateMinistry(ministry);
  }

  render() {

    if (this.state.ministry === null) { return (<div />); }

    return (
      <center>
        <div style={{maxWidth: 500, padding: 10}}>
          <FieldGroup id="name" label="Name" placeholder="Enter text" context={this} comp="ministry" />
          <FieldGroup id="description" label="Description" placeholder="Enter text" context={this} comp="ministry" componentClass="textarea" />
          <FormGroup controlId="leaders">
            <ControlLabel color="black">Leaders  <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip">If you want to change ministry leaders, send a message using the support chat in the bottom right.  State the ministry and who you want to add or remove as leaders.</Tooltip>}><Glyphicon glyph="info-sign" /></OverlayTrigger></ControlLabel>
            <FormControl type="text" value={this.state.ministry.leaders ? toCSV(Object.keys(this.state.ministry.leaders).map(key => this.state.ministry.leaders[key]), item => getLeaderName(item)) : getLeaderName(this.state.ministry.leader)} readOnly="readOnly" />
          </FormGroup>
          <FieldGroup id="email" label="Contact Email" placeholder="person@email.com" context={this} comp="ministry" />
          <FieldGroup id="facebook" label="Link to Facebook Page" context={this} comp="ministry" placeholder="https://www.facebook.com/group_identifier/" help="Just go to the group or page on FB and copy the URL from the top of your web browser." />
          <FieldGroup id="instagram" label="Instagram Handle" context={this} placeholder="@ministry_handle" comp="ministry" />
          <FieldGroup id="twitter" label="Twitter Handle" context={this} placeholder="@ministry_handle" comp="ministry" />
          <FieldGroup id="image" label="Image Link" context={this} placeholder="https://link.to.image" comp="ministry" />

          {this.state.ministry.key !== "cco" && <div>

            <FormGroup controlId="type">
              <ControlLabel color="black">Ministry Type  <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip">If you want to change ministry type, send a message using the support chat in the bottom right.  State the ministry and what you think the type should be.</Tooltip>}><Glyphicon glyph="info-sign" /></OverlayTrigger></ControlLabel>
              <FormControl type="text" value={(this.state.ministry.type === 'bible' ? 'Bible Study' : (this.state.ministry.type === 'outreach' ? 'Outreach Ministry' : 'Service Ministry')) + (this.state.ministry.youth ? ' - Youth' : '')} readOnly="readOnly" />
            </FormGroup>

            <div style={{height: 30}} />
            <CustomButtomView
              buttons={this.state.ministry.buttons}
              addButton={newButton => {
                let ministry = this.state.ministry;
                if (ministry.buttons)
                  ministry.buttons.push(newButton);
                else
                  ministry.buttons = [newButton];
                this.setState({ministry});
              }}
              removeButton={index => {
                let ministry = this.state.ministry;
                ministry.buttons.splice(index, 1);
                this.setState({ministry});
              }}
            />

          </div>}

          <div style={{height: 20}} />
          <CCOAlert in={this.state.networkAlert} type="danger" title="Network Error" content="Could not save because we could not connect to the server, please try again later." />
          <CCOAlert in={this.state.emailAlert} type="danger" title="Invalid Email" content="Please enter a valid contact email" />
          <CCOAlert in={this.state.facebookError} type="danger" title="Facebook ID Error" content="Could not find page ID from the link you provided, make sure it is in the form https://www.facebook.com/yourministryname/." />

          <div style={{height: 60}} />
          <Collapse in={JSON.stringify(this.state.baseMinistry) !== JSON.stringify(this.state.ministry)}>
            <div style={{
              position: 'fixed',
              bottom: 0, left: 0, right: 0, height: 60,
              backgroundColor: 'white',
              boxShadow: '0 -5px 5px grey'
            }}>
              <div style={{maxWidth: 300, margin: 10}}>
                <CCOButton onClick={this.save.bind(this)} text="Save Changes" type="primary" />
              </div>
            </div>
          </Collapse>
        </div>
      </center>
    );
  }
}

export default Settings;



/** WEBPACK FOOTER **
 ** ./src/ministry/Settings.js
 **/